import React from 'react';
import webStyled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareXmark, faChevronDown } from '@fortawesome/free-solid-svg-icons';

import { ModalHeader, HeaderText } from './elements';

const Controls = webStyled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ControlButton = webStyled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 0 8px;
`;

// The bar itself minimizes, so its controls must not also trigger it.
const controlClick = handler => event => {
  event.stopPropagation();
  handler();
};

const ChatHeader = ({ title, pendingResponse, onMinimize, onClose }) => (
  <ModalHeader pendingResponse={pendingResponse} onClick={onMinimize}>
    <HeaderText>{title}</HeaderText>
    <Controls>
      <ControlButton
        type="button"
        title="Minimize"
        aria-label="Minimize"
        onClick={controlClick(onMinimize)}
      >
        <FontAwesomeIcon icon={faChevronDown} size="lg" />
      </ControlButton>
      {onClose &&
        <ControlButton
          type="button"
          title="Close"
          aria-label="Close"
          onClick={controlClick(onClose)}
        >
          <FontAwesomeIcon icon={faSquareXmark} size="lg" />
        </ControlButton>
      }
    </Controls>
  </ModalHeader>
);

export default ChatHeader;
